import React from 'react';
import { useDispatch } from 'react-redux';

import { ICommentsListQuery } from '../../../../interfaces/reviews';
import { fetchCommentsList } from '../../../../store/reducers/comments';
import { CommentsList } from '../../../CommentsList';
import { TReviewCardProps } from '../../index';

interface IProps extends Pick<TReviewCardProps, 'reviewTypes' | 'showAuthPopup'> {
  reviewId?: number;
  scrollToComments: () => void;
  logo?: string;
  organizationId: string;
}

export const CompanyAnswer: React.FC<IProps> = ({
  reviewId,
  logo,
  scrollToComments,
  reviewTypes,
  organizationId,
  showAuthPopup,
}) => {
  const dispatch = useDispatch();

  const fetchComments = async (params: ICommentsListQuery) => {
    await dispatch(fetchCommentsList(params));
  };

  return (
    <CommentsList
      reviewId={reviewId}
      fetchComments={fetchComments}
      reviewTypes={reviewTypes}
      logo={logo}
      organizationId={organizationId}
      showAuthPopup={showAuthPopup}
      isBankAnswer
      scrollToComments={scrollToComments}
    />
  );
};
